import React, { useEffect, useMemo, useState } from "react";
import axios from "axios";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import Swal from "sweetalert2";
import ObtieneDatosCookies from "../obtieneDatosCookiesUsuario";
import { generarPDFDeclaracionJurada } from "../Inscripciones/generarPDFDeclaracionJurada";
import comprueboPermisos from "../tools/comprueboPermisos";
import UploadArchivosItem from "./UploadAchivoItems";
import ModuloPiscologiaIngreso from "./ModuloPiscologiaIngreso";
import EvaluarVideoEntrevista from "./EvaluarVideoEntrevista";
const API = "https://wwwa.isepsantafe.net.ar/expedientes/ingresos";

const ListadoInscriptoPsico = ({ etapa, presenteNuevo }) => {
  const Usuario = ObtieneDatosCookies();

  const puedeSubirArchivos = comprueboPermisos(
    Usuario?.funcion,
    "Subo Archivos Psicologia"
  );

  const puedeCompletarPsico = comprueboPermisos(
    Usuario?.funcion,
    "Completo Procesos Psicologia"
  );

  const puedeVerDocumentos = comprueboPermisos(
    Usuario?.funcion,
    "Veo Documentos Procesos Psicologia"
  );

  const [paginaActual, setPaginaActual] = useState(1);
  const [ordenAlfabetico, setOrdenAlfabetico] = useState("apellido_asc");
  const [modalOpen, setModalOpen] = useState(false);
  const [itemSeleccionado, setItemSeleccionado] = useState(null);
  const [tipoModal, setTipoModal] = useState(null);
  const [data, setData] = useState([]);
  const [dataLocal, setDataLocal] = useState([]);

  // Todos los presentes de todas las dependencias agrupados por DNI.
  const [presentesPorDni, setPresentesPorDni] = useState({});

  // Filtros de asistencia.
  const [filtroPresenteFecha, setFiltroPresenteFecha] = useState(null);
  const [filtroTipoAsistencia, setFiltroTipoAsistencia] = useState("todos");

  // todos | 1 | 2 | 3
  const [filtroSede, setFiltroSede] = useState("todos");

  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);

  const filasPorPagina = 100;

  const clavePaginaStorage = useMemo(() => {
    const procesoId = etapa?.proceso_id || "sin-proceso";
    const etapaId = etapa?.id || "sin-etapa";
    return `ListadoInscriptoPsicologia:pagina:${procesoId}:${etapaId}`;
  }, [etapa?.proceso_id, etapa?.id]);
  const cantidadMatriculadosEtapa = dataLocal.length;

  const sinPermiso = () => {
    Swal.fire(
      "Sin permiso",
      "No tenés permiso para realizar esta acción",
      "warning"
    );
  };

  const getColor = (item) => {
    if (item.tipo === "formulario") {
      if (item.formulario_estado === "ENVIADO") return "#d1fae5";
      if (item.formulario_estado === "BORRADOR") return "#fef9c3";
      return "#fee2e2";
    }

    if (item.estado === "aprobado") return "#00e26d";
    if (item.estado === "cargado") return "#fef9c3";
    if (item.estado === "rechazado") return "#e43313";
    if (item.estado === "en_progreso") return "#fef9c3";
    return "#fee2e2";
  };

  const getIcon = (item) => {
    if (item.tipo === "formulario") {
      if (item.formulario_estado === "ENVIADO") return "✔";
      if (item.formulario_estado === "BORRADOR") return "●";
      return "-";
    }

    if (item.estado === "aprobado") return "✔";
    if (item.estado === "rechazado") return "✖";
    if (item.estado === "en_progreso") return "●";
    if (item.estado === "cargado") return "●";
    return "-";
  };

  // =====================================================
  // FECHA / HORA PRESENTES
  // =====================================================
  const formatearHoraPresente = (valor) => {
    if (!valor) return "";

    const texto = String(valor).trim();

    if (/^\d{2}:\d{2}:\d{2}$/.test(texto)) {
      return texto;
    }

    const fecha = new Date(texto);

    if (!Number.isNaN(fecha.getTime())) {
      return fecha.toLocaleTimeString(
        "es-AR",
        {
          timeZone:
            "America/Argentina/Buenos_Aires",
          hour12: false,
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        }
      );
    }

    return texto;
  };

  const formatearFechaPresente = (valor) => {
    if (!valor) return "";

    const texto = String(valor).trim();

    if (/^\d{4}-\d{2}-\d{2}$/.test(texto)) {
      const [anio, mes, dia] =
        texto.split("-");

      return `${dia}/${mes}/${anio}`;
    }

    const fecha = new Date(texto);

    if (!Number.isNaN(fecha.getTime())) {
      return fecha.toLocaleDateString(
        "es-AR",
        {
          timeZone:
            "America/Argentina/Buenos_Aires",
        }
      );
    }

    return texto;
  };

  // =====================================================
  // PRESENTES DE TODAS LAS DEPENDENCIAS
  // =====================================================
  const getPresentesPersona = (personaProceso) => {
    const dni = String(
      personaProceso?.persona?.dni || ""
    ).trim();

    const presentes = presentesPorDni[dni];

    if (Array.isArray(presentes) && presentes.length > 0) {
      return presentes;
    }

    // Compatibilidad con respuestas que todavía traigan un único presente.
    if (personaProceso?.presente) {
      return [personaProceso.presente];
    }

    return [];
  };

  const getPresentePsico = (personaProceso) => {
    const presentes = getPresentesPersona(personaProceso);

    const presentesPsico = presentes.filter((presente) => {
      const dependencia = String(
        presente?.dependencia || ""
      )
        .toLowerCase()
        .trim();

      return (
        dependencia === "psicologia" ||
        dependencia === "psicología"
      );
    });

    if (!presentesPsico.length) {
      return null;
    }

    return [...presentesPsico].sort((a, b) => {
      const valorA = `${a?.fecha || ""} ${a?.hora || ""}`;
      const valorB = `${b?.fecha || ""} ${b?.hora || ""}`;

      return valorB.localeCompare(valorA);
    })[0];
  };

  const getNombreSede = (sedeID) => {
    const mapaSedes = {
      1: "Provincial",
      2: "Rosario",
      3: "Recreo",
    };

    if (sedeID === null || sedeID === undefined || sedeID === "") {
      return "Sin sede";
    }

    return mapaSedes[Number(sedeID)] || `Sede ${sedeID}`;
  };

  const getSedesPersona = (personaProceso) => {
    const presentes = getPresentesPersona(personaProceso);

    const sedes = presentes
      .map((presente) => getNombreSede(presente?.sedeID))
      .filter(Boolean);

    return [...new Set(sedes)];
  };

  const getColorDependencia = (dependencia) => {
    const texto = String(
      dependencia || "sin dependencia"
    )
      .toLowerCase()
      .trim();

    const colores = [
      "#14532d",
      "#166534",
      "#15803d",
      "#16a34a",
      "#22c55e",
      "#4ade80",
      "#059669",
      "#047857",
      "#0f766e",
    ];

    let hash = 0;

    for (let i = 0; i < texto.length; i++) {
      hash = (hash * 31 + texto.charCodeAt(i)) >>> 0;
    }

    return colores[hash % colores.length];
  };

  const getColorTextoDependencia = (dependencia) => {
    const color = getColorDependencia(dependencia);

    return color === "#4ade80" || color === "#22c55e"
      ? "#052e16"
      : "#ffffff";
  };

  // =====================================================
  // AGREGAR PRESENTE NUEVO SIN CONSULTAR DE NUEVO
  // =====================================================
  const agregarPresenteLocal = (registro) => {
    if (!registro) return;

    const dni = String(registro?.dni || "").trim();

    if (!dni) return;

    const etapaRegistro = String(
      registro?.proceso_etapa_id || ""
    );

    const etapaActual = String(
      etapa?.id || ""
    );

    if (
      etapaRegistro &&
      etapaActual &&
      etapaRegistro !== etapaActual
    ) {
      return;
    }

    setPresentesPorDni((prev) => {
      const actuales = Array.isArray(prev[dni])
        ? prev[dni]
        : [];

      const yaExiste = actuales.some((presente) => {
        if (registro?.id && presente?.id) {
          return String(registro.id) === String(presente.id);
        }

        return (
          String(presente?.dependencia || "").trim() ===
            String(registro?.dependencia || "").trim() &&
          String(presente?.fecha || "").trim() ===
            String(registro?.fecha || "").trim() &&
          String(presente?.hora || "").trim() ===
            String(registro?.hora || "").trim()
        );
      });

      if (yaExiste) {
        return prev;
      }

      const nuevos = [
        ...actuales,
        {
          ...registro,
          dni,
          proceso_etapa_id:
            registro?.proceso_etapa_id ||
            etapa?.id,
        },
      ].sort((a, b) => {
        const valorA = `${a?.fecha || ""} ${a?.hora || ""}`;
        const valorB = `${b?.fecha || ""} ${b?.hora || ""}`;

        return valorA.localeCompare(valorB);
      });

      return {
        ...prev,
        [dni]: nuevos,
      };
    });
  };

  const fetchPresentes = async () => {
    try {
      if (!etapa?.id) {
        setPresentesPorDni({});
        return;
      }

      // Sin dependencia: trae presentes de Psicología, Sanidad,
      // Inscripción, Especialidades, Procesos, etc.
      const res = await axios.post(
        `${API}/listarPresentesEtapa`,
        {
          proceso_etapa_id: etapa.id,
        }
      );

      const lista = Array.isArray(res.data?.presentes)
        ? res.data.presentes
        : [];

      const mapa = {};

      lista.forEach((presente) => {
        const dni = String(presente?.dni || "").trim();

        if (!dni) return;

        if (!mapa[dni]) {
          mapa[dni] = [];
        }

        mapa[dni].push(presente);
      });

      Object.keys(mapa).forEach((dni) => {
        mapa[dni] = mapa[dni].sort((a, b) => {
          const valorA = `${a?.fecha || ""} ${a?.hora || ""}`;
          const valorB = `${b?.fecha || ""} ${b?.hora || ""}`;

          return valorA.localeCompare(valorB);
        });
      });

      setPresentesPorDni(mapa);
    } catch (error) {
      console.error(
        "Error cargando presentes de todas las dependencias:",
        error
      );

      setPresentesPorDni({});
    }
  };

  const mostrarPresentes = (presentes = []) => {
    if (!Array.isArray(presentes) || presentes.length === 0) {
      return;
    }

    const html = presentes
      .map((presente) => {
        const dependencia =
          presente?.dependencia || "Sin dependencia";

        const color = getColorDependencia(dependencia);
        const colorTexto = getColorTextoDependencia(dependencia);

        return `
          <div
            style="
              text-align:left;
              padding:12px;
              margin-bottom:10px;
              border-radius:10px;
              background:${color};
              color:${colorTexto};
            "
          >
            <div style="font-weight:800;margin-bottom:6px">
              ✔ ${dependencia}
            </div>

            <div>
              <b>Fecha:</b>
              ${formatearFechaPresente(presente?.fecha) || "—"}
            </div>

            <div>
              <b>Hora:</b>
              ${formatearHoraPresente(presente?.hora) || "—"}
            </div>

            <div>
              <b>Usuario:</b>
              ${presente?.usuario || "—"}
            </div>

            <div>
              <b>Sede:</b>
              ${getNombreSede(presente?.sedeID)}
            </div>
          </div>
        `;
      })
      .join("");

    Swal.fire({
      title:
        presentes.length === 1
          ? "Presente registrado"
          : `Presentes registrados (${presentes.length})`,
      html: `
        <div style="max-height:450px;overflow:auto;padding-right:4px">
          ${html}
        </div>
      `,
      icon: "info",
      width: 700,
      confirmButtonText: "Cerrar",
    });
  };

  const fetchData = async () => {
    try {
      setLoading(true);

      // Usamos el mismo endpoint general para traer a todos los
      // matriculados de la etapa.
      const res = await axios.post(`${API}/getPersonasPorEtapa`, {
        proceso_etapa_id: etapa.id,
      });

      const personas = Array.isArray(res.data?.personas)
        ? res.data.personas
        : [];

      // Conservamos todas las personas, pero mostramos solamente
      // ítems de Psicología o ítems generales sin restricción.
      const personasPsico = personas.map((personaProceso) => ({
        ...personaProceso,
        instancias:
          personaProceso?.instancias?.map((instancia) => ({
            ...instancia,
            items:
              instancia?.items?.filter((item) => {
                const visible = String(
                  item?.visible || ""
                )
                  .toLowerCase()
                  .trim();

                return (
                  !visible ||
                  visible.includes("psicologia") ||
                  visible.includes("psicología")
                );
              }) || [],
          })) || [],
      }));

      setData(personasPsico);
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "No se pudo cargar Psicología", "error");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (!etapa?.id) return;

    const paginaGuardada = Number(localStorage.getItem(clavePaginaStorage));

    setPaginaActual(
      Number.isInteger(paginaGuardada) && paginaGuardada > 0
        ? paginaGuardada
        : 1
    );

    fetchData();
    fetchPresentes();
  }, [etapa, clavePaginaStorage]);

useEffect(() => {
    setDataLocal(data);
  }, [data]);

  // El lector devuelve el registro recién creado.
  // Lo pintamos localmente sin volver a consultar.
  useEffect(() => {
    if (!presenteNuevo) return;

    agregarPresenteLocal(
      presenteNuevo
    );
  }, [presenteNuevo, etapa?.id]);

  useEffect(() => {
    if (!etapa?.id) return;

    localStorage.setItem(
      clavePaginaStorage,
      String(paginaActual)
    );
  }, [paginaActual, clavePaginaStorage, etapa?.id]);

  const resumenPresentes = useMemo(() => {
    const porFecha = {};
    const porDependencia = {};

    let totalPersonasConPresente = 0;
    let totalRegistros = 0;

    dataLocal.forEach((personaProceso) => {
      const presentes = getPresentesPersona(personaProceso);

      if (presentes.length > 0) {
        totalPersonasConPresente++;
      }

      // Una persona cuenta una sola vez por fecha aunque tenga
      // más de un presente ese mismo día.
      const fechasPersona = new Set();

      presentes.forEach((presente) => {
        const fecha = String(
          presente?.fecha || ""
        ).trim();

        if (fecha) {
          fechasPersona.add(fecha);
        }

        const dependencia = String(
          presente?.dependencia || "Sin dependencia"
        ).trim();

        if (!porDependencia[dependencia]) {
          porDependencia[dependencia] = 0;
        }

        porDependencia[dependencia]++;
        totalRegistros++;
      });

      fechasPersona.forEach((fecha) => {
        if (!porFecha[fecha]) {
          porFecha[fecha] = 0;
        }

        porFecha[fecha]++;
      });
    });

    return {
      porFecha,
      porDependencia,
      totalPersonasConPresente,
      totalRegistros,
    };
  }, [dataLocal, presentesPorDni]);

  const filteredData = useMemo(() => {
    return dataLocal.filter((item) => {
      const p = item.persona || {};

      const texto = `${p.dni || ""} ${p.nombre || ""} ${
        p.apellido || ""
      }`.toLowerCase();

      if (!texto.includes(search.toLowerCase())) {
        return false;
      }

      const presentesPersona = getPresentesPersona(item);

      if (filtroPresenteFecha) {
        const tienePresenteEnFecha = presentesPersona.some(
          (presente) =>
            String(presente?.fecha || "") ===
            String(filtroPresenteFecha)
        );

        if (
          filtroTipoAsistencia === "presentes" &&
          !tienePresenteEnFecha
        ) {
          return false;
        }

        if (
          filtroTipoAsistencia === "restantes" &&
          tienePresenteEnFecha
        ) {
          return false;
        }
      }

      // =====================================================
      // FILTRO POR SEDE DONDE SE TOMÓ EL PRESENTE
      // =====================================================
      if (filtroSede !== "todos") {
        const tienePresenteEnSede = presentesPersona.some(
          (presente) =>
            String(presente?.sedeID || "") ===
            String(filtroSede)
        );

        if (!tienePresenteEnSede) {
          return false;
        }
      }

      return true;
    });
  }, [
    dataLocal,
    search,
    filtroPresenteFecha,
    filtroTipoAsistencia,
    filtroSede,
    presentesPorDni,
  ]);

  useEffect(() => {
    setPaginaActual(1);
  }, [
    search,
    filtroPresenteFecha,
    filtroTipoAsistencia,
    filtroSede,
  ]);

  const dataOrdenada = useMemo(() => {
    const lista = [...filteredData];

    const compararTexto = (a, b) =>
      String(a || "").localeCompare(String(b || ""), "es", {
        sensitivity: "base",
        numeric: true,
      });

    lista.sort((filaA, filaB) => {
      const personaA = filaA?.persona || {};
      const personaB = filaB?.persona || {};

      if (ordenAlfabetico === "apellido_desc") {
        return (
          compararTexto(personaB.apellido, personaA.apellido) ||
          compararTexto(personaB.nombre, personaA.nombre)
        );
      }

      if (ordenAlfabetico === "nombre_asc") {
        return (
          compararTexto(personaA.nombre, personaB.nombre) ||
          compararTexto(personaA.apellido, personaB.apellido)
        );
      }

      if (ordenAlfabetico === "nombre_desc") {
        return (
          compararTexto(personaB.nombre, personaA.nombre) ||
          compararTexto(personaB.apellido, personaA.apellido)
        );
      }

      return (
        compararTexto(personaA.apellido, personaB.apellido) ||
        compararTexto(personaA.nombre, personaB.nombre)
      );
    });

    return lista;
  }, [filteredData, ordenAlfabetico]);

  const totalPaginas =
    Math.ceil(dataOrdenada.length / filasPorPagina) || 1;

  useEffect(() => {
    if (paginaActual > totalPaginas) {
      setPaginaActual(totalPaginas);
    }
  }, [paginaActual, totalPaginas]);

  const dataPaginada = useMemo(() => {
    const inicio = (paginaActual - 1) * filasPorPagina;
    const fin = inicio + filasPorPagina;
    return dataOrdenada.slice(inicio, fin);
  }, [dataOrdenada, paginaActual]);

  const resumenPorInstancia = useMemo(() => {
    const resumen = {};

    filteredData.forEach((p) => {
      p.instancias?.forEach((inst) => {
        if (!resumen[inst.id]) {
          resumen[inst.id] = {
            aprobado: 0,
            pendiente: 0,
            en_progreso: 0,
            nombre: inst.nombre,
          };
        }

        inst.items?.forEach((item) => {
          if (item.tipo === "formulario") {
            if (item.formulario_estado === "ENVIADO") {
              resumen[inst.id].aprobado++;
            } else if (item.formulario_estado === "BORRADOR") {
              resumen[inst.id].en_progreso++;
            } else {
              resumen[inst.id].pendiente++;
            }
          } else {
            if (item.estado === "aprobado") {
              resumen[inst.id].aprobado++;
            } else if (
              item.estado === "en_progreso" ||
              item.estado === "cargado"
            ) {
              resumen[inst.id].en_progreso++;
            } else {
              resumen[inst.id].pendiente++;
            }
          }
        });
      });
    });

    return resumen;
  }, [filteredData]);

  const abrirFormulario = async (item) => {
    try {
      const res = await axios.post(`${API}/obtenerDeclaracionJurada`, {
        dni: item.dni || item.persona_dni || null,
        persona_id: item.persona_id,
        formulario_id: item.formulario_id,
      });

      generarPDFDeclaracionJurada(res.data);
    } catch (error) {
      console.error(error);
      Swal.fire("Error", "No se pudo abrir el formulario", "error");
    }
  };

  const descargarPDF = async (persona, etapaPsico) => {
    try {
      const dni = persona.dni;

      const response = await axios.post(
        "https://wwwp.isepsantafe.net.ar/psicologia/pdf_respuestas_scl90",
        {
          dni,
          etapa: etapaPsico,
        },
        {
          responseType: "blob",
          headers: {
            Authorization:
              "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c3VhcmlvIjoibGVhbmRybyJ9.XprcUoRssqDYD-gFEJ1j5F60bXWaPK4fzO_56yZ4aqw",
          },
        }
      );

      const blob = new Blob([response.data], {
        type: "application/pdf",
      });

      const url = window.URL.createObjectURL(blob);
      const nuevaVentana = window.open("", "_blank");

      if (!nuevaVentana) {
        Swal.fire("Atención", "El navegador bloqueó la ventana emergente", "warning");
        return;
      }

      nuevaVentana.document.write(`
        <html>
          <head>
            <title>SCL90_${dni}</title>
            <style>
              html, body {
                margin: 0;
                height: 100%;
              }

              iframe {
                width: 100%;
                height: 100%;
                border: none;
              }
            </style>
          </head>

          <body>
            <iframe src="${url}"></iframe>
          </body>
        </html>
      `);

      nuevaVentana.document.close();
    } catch (error) {
      console.error(error);

      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudo abrir el PDF",
      });
    }
  };

  const SuboArchivosPsico = (persona, instancia, item) => {
    setItemSeleccionado({
      persona,
      instancia,
      item,
    });

    setTipoModal("archivo");
    setModalOpen(true);
  };

  const abroExamenPsico = (persona, instancia, item) => {
    setItemSeleccionado({
      persona,
      instancia,
      item,
    });

    setTipoModal("examen");
    setModalOpen(true);
  };

  const handleClickItem = (p, inst, item) => {
    if (item.tipo === "archivo") {
      if (!puedeSubirArchivos) {
        sinPermiso();
        return;
      }

      SuboArchivosPsico(p.persona, inst.id, item);
      return;
    }

    if (item.tipo === "evaluacion" && item.observacion === "SCL90") {
      if (!puedeCompletarPsico) {
        sinPermiso();
        return;
      }

      descargarPDF(p.persona, "Auxiliar Forense 2026");
      return;
    }

    if (item.tipo === "evaluacion" && item.observacion !== "SCL90") {
      if (!puedeCompletarPsico) {
        sinPermiso();
        return;
      }

      abroExamenPsico(p.persona, inst.id, item);
      return;
    }
if (item.tipo === "video") {
  if (!puedeCompletarPsico) {
    sinPermiso();
    return;
  }

  setItemSeleccionado({
    persona: p.persona,
    instancia: inst.id,
    item,
  });

  setTipoModal("video");
  setModalOpen(true);
  return;
}
    if (item.tipo === "formulario") {
      if (!puedeVerDocumentos) {
        sinPermiso();
        return;
      }

      abrirFormulario({
        ...item,
        dni: p.persona.dni,
        persona_id: p.persona.id,
      });
    }
  };

  const puedeAccionarItem = (item) => {
    if (item.tipo === "archivo") return puedeSubirArchivos;
    if (item.tipo === "evaluacion") return puedeCompletarPsico;
    if (item.tipo === "formulario") return puedeVerDocumentos;
      if (item.tipo === "video") return puedeCompletarPsico;
    return false;
  };

  const exportToExcel = () => {
    const flat = [];

    filteredData.forEach((p) => {
      p.instancias?.forEach((inst) => {
        inst.items?.forEach((item) => {
          const presentes = getPresentesPersona(p);
          const presentePsico = getPresentePsico(p);

          const sedesPersona = presentes
            .map((presente) =>
              getNombreSede(presente?.sedeID)
            )
            .filter(
              (sede, index, array) =>
                array.indexOf(sede) === index
            );

          flat.push({
            DNI: p.persona.dni,
            Nombre: p.persona.nombre,
            Apellido: p.persona.apellido,

            TienePresente:
              presentes.length > 0 ? "SI" : "NO",

            CantidadPresentes:
              presentes.length,

            DependenciasPresentes:
              presentes
                .map(
                  (presente) =>
                    presente?.dependencia ||
                    "Sin dependencia"
                )
                .join(" | "),

            UsuariosPresentes:
              presentes
                .map(
                  (presente) =>
                    `${presente?.dependencia || "Sin dependencia"}: ${
                      presente?.usuario || ""
                    }`
                )
                .join(" | "),

            SedesPresentes:
              sedesPersona.join(" | "),

            PresentePsicologia:
              presentePsico ? "SI" : "NO",

            FechaPresentePsicologia:
              formatearFechaPresente(
                presentePsico?.fecha
              ),

            HoraPresentePsicologia:
              formatearHoraPresente(
                presentePsico?.hora
              ),

            UsuarioPresentePsicologia:
              presentePsico?.usuario || "",

            SedePresentePsicologia:
              presentePsico
                ? getNombreSede(
                    presentePsico?.sedeID
                  )
                : "",

            Instancia: inst.nombre,
            Item: item.nombre || item.descripcion,
            Tipo: item.tipo || "",
            Estado: item.estado || "",
            Resultado: item.resultado || "",
            FormularioEstado:
              item.formulario_estado || "",
          });
        });
      });
    });

    // =====================================================
    // HELPERS EXCEL
    // =====================================================
    const normalizarExcel = (valor) =>
      String(valor || "")
        .toLowerCase()
        .trim();

    const esAprobadoExcel = (fila) => {
      const estado = normalizarExcel(fila.Estado);
      const resultado = normalizarExcel(fila.Resultado);
      const formularioEstado =
        normalizarExcel(fila.FormularioEstado);

      return (
        estado === "aprobado" ||
        estado === "completado" ||
        estado === "completo" ||
        resultado === "aprobado" ||
        resultado === "completado" ||
        resultado === "completo" ||
        resultado === "apto" ||
        formularioEstado === "enviado"
      );
    };

    const esEnProcesoExcel = (fila) => {
      const estado = normalizarExcel(fila.Estado);
      const formularioEstado =
        normalizarExcel(fila.FormularioEstado);

      return (
        estado === "en_progreso" ||
        estado === "cargado" ||
        formularioEstado === "borrador"
      );
    };

    const esRechazadoExcel = (fila) => {
      const estado = normalizarExcel(fila.Estado);
      const resultado = normalizarExcel(fila.Resultado);

      return (
        estado === "rechazado" ||
        resultado === "rechazado" ||
        resultado === "no apto" ||
        resultado === "no_apto"
      );
    };

    const esPendienteExcel = (fila) =>
      !esAprobadoExcel(fila) &&
      !esEnProcesoExcel(fila) &&
      !esRechazadoExcel(fila);

    const agregarHoja = (
      workbook,
      nombre,
      filas
    ) => {
      if (!Array.isArray(filas)) {
        filas = [];
      }

      const hoja = XLSX.utils.json_to_sheet(
        filas.length > 0
          ? filas
          : [
              {
                Informacion:
                  "No hay registros para esta hoja",
              },
            ]
      );

      // Ancho básico de columnas para que salga legible.
      const columnas = Object.keys(
        filas[0] || {
          Informacion: "",
        }
      );

      hoja["!cols"] = columnas.map(
        (columna) => ({
          wch: Math.min(
            Math.max(
              columna.length + 2,
              12
            ),
            35
          ),
        })
      );

      XLSX.utils.book_append_sheet(
        workbook,
        hoja,
        nombre.substring(0, 31)
      );
    };

    // =====================================================
    // CREAR LIBRO
    // =====================================================
    const wb = XLSX.utils.book_new();

    // =====================================================
    // HOJA GENERAL
    // =====================================================
    agregarHoja(
      wb,
      "Todos",
      flat
    );

    // =====================================================
    // HOJAS POR SEDE
    // =====================================================
    agregarHoja(
      wb,
      "Provincial",
      flat.filter((fila) =>
        String(fila.SedesPresentes || "")
          .split("|")
          .map((s) => s.trim())
          .includes("Provincial")
      )
    );

    agregarHoja(
      wb,
      "Rosario",
      flat.filter((fila) =>
        String(fila.SedesPresentes || "")
          .split("|")
          .map((s) => s.trim())
          .includes("Rosario")
      )
    );

    agregarHoja(
      wb,
      "Recreo",
      flat.filter((fila) =>
        String(fila.SedesPresentes || "")
          .split("|")
          .map((s) => s.trim())
          .includes("Recreo")
      )
    );

    agregarHoja(
      wb,
      "Sin sede",
      flat.filter(
        (fila) =>
          !fila.SedesPresentes ||
          fila.SedesPresentes === "Sin sede"
      )
    );

    // =====================================================
    // HOJAS POR ESTADO
    // =====================================================
    agregarHoja(
      wb,
      "Aprobados",
      flat.filter(esAprobadoExcel)
    );

    agregarHoja(
      wb,
      "En proceso",
      flat.filter(esEnProcesoExcel)
    );

    agregarHoja(
      wb,
      "Pendientes",
      flat.filter(esPendienteExcel)
    );

    agregarHoja(
      wb,
      "Rechazados",
      flat.filter(esRechazadoExcel)
    );

    // =====================================================
    // HOJAS POR ASISTENCIA
    // =====================================================
    agregarHoja(
      wb,
      "Con presente",
      flat.filter(
        (fila) =>
          fila.TienePresente === "SI"
      )
    );

    agregarHoja(
      wb,
      "Sin presente",
      flat.filter(
        (fila) =>
          fila.TienePresente !== "SI"
      )
    );

    // =====================================================
    // HOJAS ESPECÍFICAS DE PSICOLOGÍA
    // =====================================================
    agregarHoja(
      wb,
      "Presente Psicologia",
      flat.filter(
        (fila) =>
          fila.PresentePsicologia === "SI"
      )
    );

    agregarHoja(
      wb,
      "Sin presente Psicologia",
      flat.filter(
        (fila) =>
          fila.PresentePsicologia !== "SI"
      )
    );

    // =====================================================
    // EXPORTAR
    // =====================================================
    const buffer = XLSX.write(
      wb,
      {
        bookType: "xlsx",
        type: "array",
      }
    );

    saveAs(
      new Blob([buffer]),
      `psicologia_${etapa.nombre}_completo.xlsx`
    );
  };

  if (loading) return <p>Cargando...</p>;

  return (
    <div
      style={{
        background: "#fff",
        padding: 15,
        marginTop: 10,
        width: "100%",
        maxWidth: "100%",
        overflowX: "auto",
      }}
    >
      <h4>🧠 {etapa.nombre} - Psicología</h4>

      <div style={styles.resumenContainer}>
        <div style={styles.cardMatriculados}>
          <b>Matriculados etapa</b>

          <div style={styles.numeroMatriculados}>
            {cantidadMatriculadosEtapa}
          </div>

          <div style={styles.resumenTexto}>
            Filtrados: {filteredData.length}
          </div>

          <div style={styles.resumenPresentesGeneral}>
            <div>
              ✔ Con algún presente:{" "}
              <b>{resumenPresentes.totalPersonasConPresente}</b>
            </div>

            <div>
              🧾 Registros de presente:{" "}
              <b>{resumenPresentes.totalRegistros}</b>
            </div>
          </div>
        </div>

        {Object.values(resumenPorInstancia).map((r, i) => (
          <div key={i} style={styles.cardResumen}>
            <b>{r.nombre}</b>

            <div style={styles.resumenTexto}>✔ Completados {r.aprobado}</div>
            <div style={styles.resumenTexto}>● En proceso {r.en_progreso}</div>
            <div style={styles.resumenTexto}>✖ Pendientes {r.pendiente}</div>
          </div>
        ))}
      </div>

      <div style={styles.asistenciaPorFechaContainer}>
        <div style={styles.asistenciaPorFechaHeader}>
          <div>
            <b>📅 Presentes por fecha</b>

            <div style={styles.asistenciaAyuda}>
              Tocá Presentes para ver sólo quienes dieron presente
              ese día, o Ausentes para ver quienes todavía no lo dieron.
            </div>
          </div>

          <div style={styles.asistenciaFechaManual}>
            <input
              type="date"
              value={filtroPresenteFecha || ""}
              onChange={(e) => {
                const fecha = e.target.value;

                if (!fecha) {
                  setFiltroPresenteFecha(null);
                  setFiltroTipoAsistencia("todos");
                  return;
                }

                setFiltroPresenteFecha(fecha);
                setFiltroTipoAsistencia("presentes");
                setPaginaActual(1);
              }}
              style={styles.inputFechaAsistencia}
            />

            {filtroPresenteFecha && (
              <button
                type="button"
                onClick={() => {
                  setFiltroPresenteFecha(null);
                  setFiltroTipoAsistencia("todos");
                  setPaginaActual(1);
                }}
                style={styles.btnLimpiarAsistencia}
              >
                ✖ Limpiar
              </button>
            )}
          </div>
        </div>

        <div style={styles.fechasAsistenciaGrid}>
          {Object.entries(resumenPresentes.porFecha)
            .sort(([fechaA], [fechaB]) =>
              fechaB.localeCompare(fechaA)
            )
            .map(([fecha, cantidadPresentes]) => {
              const cantidadAusentes = Math.max(
                cantidadMatriculadosEtapa -
                  cantidadPresentes,
                0
              );

              const fechaActiva =
                filtroPresenteFecha === fecha;

              const presentesActivo =
                fechaActiva &&
                filtroTipoAsistencia === "presentes";

              const ausentesActivo =
                fechaActiva &&
                filtroTipoAsistencia === "restantes";

              return (
                <div
                  key={fecha}
                  style={{
                    ...styles.cardAsistenciaFecha,
                    borderColor: fechaActiva
                      ? "#2563eb"
                      : "#bbf7d0",
                  }}
                >
                  <div style={styles.fechaAsistenciaTitulo}>
                    📅 {formatearFechaPresente(fecha)}
                  </div>

                  <button
                    type="button"
                    onClick={() => {
                      setFiltroPresenteFecha(fecha);
                      setFiltroTipoAsistencia("presentes");
                      setPaginaActual(1);
                    }}
                    style={{
                      ...styles.btnFechaPresentes,
                      ...(presentesActivo
                        ? styles.btnFechaPresentesActivo
                        : {}),
                    }}
                  >
                    ✔ Presentes{" "}
                    <b>{cantidadPresentes}</b>
                  </button>

                  <button
                    type="button"
                    onClick={() => {
                      setFiltroPresenteFecha(fecha);
                      setFiltroTipoAsistencia("restantes");
                      setPaginaActual(1);
                    }}
                    style={{
                      ...styles.btnFechaAusentes,
                      ...(ausentesActivo
                        ? styles.btnFechaAusentesActivo
                        : {}),
                    }}
                  >
                    ⏳ Ausentes{" "}
                    <b>{cantidadAusentes}</b>
                  </button>

                  <div style={styles.totalFechaAsistencia}>
                    👥 Total{" "}
                    <b>{cantidadMatriculadosEtapa}</b>
                  </div>
                </div>
              );
            })}

          {Object.keys(resumenPresentes.porFecha).length === 0 && (
            <div style={styles.sinFechasAsistencia}>
              Todavía no hay registros de presentes para esta etapa.
            </div>
          )}
        </div>

        {filtroPresenteFecha && (
          <div style={styles.filtroFechaActivo}>
            Mostrando:{" "}
            <b>
              {filtroTipoAsistencia === "restantes"
                ? "Ausentes"
                : "Presentes"}
            </b>{" "}
            del{" "}
            <b>
              {formatearFechaPresente(
                filtroPresenteFecha
              )}
            </b>
            {" · "}
            <b>{filteredData.length}</b> persona(s)
          </div>
        )}
      </div>

      {filtroSede !== "todos" && (
        <div style={styles.filtroSedeActivo}>
          <b>📍 Sede:</b>{" "}
          {getNombreSede(filtroSede)}

          <button
            type="button"
            onClick={() => {
              setFiltroSede("todos");
              setPaginaActual(1);
            }}
            style={styles.btnLimpiarSede}
          >
            ✖ Ver todas
          </button>
        </div>
      )}

      <div style={styles.paginador}>
        <button
          onClick={() => setPaginaActual((p) => Math.max(p - 1, 1))}
          disabled={paginaActual === 1}
        >
          ⬅ Anterior
        </button>

        <span>
          Página {paginaActual} de {totalPaginas}
          {" · "}
          {dataOrdenada.length > 0
            ? `${(paginaActual - 1) * filasPorPagina + 1}-${Math.min(
                paginaActual * filasPorPagina,
                dataOrdenada.length
              )} de ${dataOrdenada.length}`
            : "0 registros"}
          {" · "}posición guardada
        </span>

        <button
          onClick={() =>
            setPaginaActual((p) => Math.min(p + 1, totalPaginas))
          }
          disabled={paginaActual === totalPaginas}
        >
          Siguiente ➡
        </button>
      </div>

      <div style={styles.buscadorContainer}>
        <input
          placeholder="Buscar persona"
          value={search}
          onChange={(e) => {
            setSearch(e.target.value);
            setPaginaActual(1);
          }}
          style={styles.inputBuscar}
        />

        <select
          value={filtroSede}
          onChange={(e) => {
            setFiltroSede(e.target.value);
            setPaginaActual(1);
          }}
          style={styles.selectOrdenAlfabetico}
          title="Filtrar por sede donde se tomó el presente"
        >
          <option value="todos">Todas las sedes</option>
          <option value="1">Provincial</option>
          <option value="2">Rosario</option>
          <option value="3">Recreo</option>
        </select>

        <select
          value={ordenAlfabetico}
          onChange={(e) => setOrdenAlfabetico(e.target.value)}
          style={styles.selectOrdenAlfabetico}
          title="Ordenar filas"
        >
          <option value="apellido_asc">Apellido A → Z</option>
          <option value="apellido_desc">Apellido Z → A</option>
          <option value="nombre_asc">Nombre A → Z</option>
          <option value="nombre_desc">Nombre Z → A</option>
        </select>

        <button onClick={exportToExcel}>Excel</button>
      </div>

      {!isMobile && (
        <table style={styles.tabla}>
          <thead>
            <tr>
              <th style={styles.th}>#</th>
              <th style={styles.th}>DNI</th>
              <th style={styles.th}>Apellido</th>
              <th style={styles.th}>Nombre</th>
              <th style={styles.th}>
                Presentes
              </th>

              <th style={styles.th}>
                Sede
              </th>

              {dataPaginada[0]?.instancias?.map((inst) => (
                <th key={inst.id} style={styles.th}>
                  {inst.nombre}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {dataPaginada.map((p, index) => (
              <tr
                key={p.persona.dni}
                style={{
                  background: index % 2 === 0 ? "#ffffff" : "#f8fafc",
                }}
              >
                <td style={styles.td}>
                  {(paginaActual - 1) * filasPorPagina + index + 1}
                </td>

                <td style={styles.td}>{p.persona.dni}</td>
                <td style={styles.td}>{p.persona.apellido}</td>
                <td style={styles.td}>{p.persona.nombre}</td>

                <td style={styles.td}>
                  {getPresentesPersona(p).length > 0 ? (
                    <div style={styles.presentesContainer}>
                      {getPresentesPersona(p).map(
                        (presente, indexPresente) => (
                          <button
                            key={
                              presente?.id ||
                              `${presente?.dependencia}-${presente?.fecha}-${presente?.hora}-${indexPresente}`
                            }
                            type="button"
                            onClick={() =>
                              mostrarPresentes(
                                getPresentesPersona(p)
                              )
                            }
                            style={{
                              ...styles.presenteDependenciaChip,
                              background:
                                getColorDependencia(
                                  presente?.dependencia
                                ),
                              color:
                                getColorTextoDependencia(
                                  presente?.dependencia
                                ),
                            }}
                            title={`Presente dado por ${
                              presente?.dependencia ||
                              "Sin dependencia"
                            } - Usuario: ${
                              presente?.usuario || "—"
                            }`}
                          >
                            <b>
                              ✔{" "}
                              {presente?.dependencia ||
                                "Sin dependencia"}
                            </b>

                            <span>
                              {formatearFechaPresente(
                                presente?.fecha
                              )}{" "}
                              {formatearHoraPresente(
                                presente?.hora
                              )}
                            </span>

                            <span style={styles.usuarioPresente}>
                              {presente?.usuario || ""}
                            </span>

                            <span style={styles.sedePresente}>
                              📍 {getNombreSede(presente?.sedeID)}
                            </span>
                          </button>
                        )
                      )}
                    </div>
                  ) : (
                    <span style={styles.ausentePsicoChip}>
                      —
                    </span>
                  )}
                </td>

                <td style={styles.td}>
                  {getSedesPersona(p).length > 0 ? (
                    <div style={styles.sedesContainer}>
                      {getSedesPersona(p).map((sede) => (
                        <span
                          key={sede}
                          style={styles.sedeChip}
                        >
                          📍 {sede}
                        </span>
                      ))}
                    </div>
                  ) : (
                    <span style={styles.sinSedeChip}>
                      —
                    </span>
                  )}
                </td>

                {p.instancias?.map((inst) => (
                  <td key={inst.id} style={styles.td}>
                    <div style={styles.itemsContainer}>
                      {inst.items?.map((item, i) => (
                        <span
                          key={item.id}
                          onClick={() => handleClickItem(p, inst, item)}
                          style={{
                            ...styles.itemChip,
                            cursor: puedeAccionarItem(item)
                              ? "pointer"
                              : "not-allowed",
                            opacity: puedeAccionarItem(item) ? 1 : 0.6,
                            background: getColor(item),
                          }}
                          title={item.descripcion || item.nombre || ""}
                        >
                          {item.descripcion || item.nombre || `Item ${i + 1}`}{" "}
                          {getIcon(item)}
                        </span>
                      ))}
                    </div>
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {isMobile && (
        <div style={{ marginTop: 10 }}>
          {dataPaginada.map((p, index) => (
            <div
              key={p.persona.dni}
              style={{
                ...styles.cardMobile,
                background: index % 2 === 0 ? "#fff" : "#f8fafc",
              }}
            >
              <b>
                #{(paginaActual - 1) * filasPorPagina + index + 1} -{" "}
                {p.persona.apellido}, {p.persona.nombre}
              </b>

              <div>DNI: {p.persona.dni}</div>

              <div style={{ marginTop: 6 }}>
                {getPresentesPersona(p).length > 0 ? (
                  <div style={styles.presentesMobileContainer}>
                    {getPresentesPersona(p).map(
                      (presente, indexPresente) => (
                        <div
                          key={
                            presente?.id ||
                            `${presente?.dependencia}-${presente?.fecha}-${presente?.hora}-${indexPresente}`
                          }
                          onClick={() =>
                            mostrarPresentes(
                              getPresentesPersona(p)
                            )
                          }
                          style={{
                            ...styles.presenteDependenciaMobile,
                            background:
                              getColorDependencia(
                                presente?.dependencia
                              ),
                            color:
                              getColorTextoDependencia(
                                presente?.dependencia
                              ),
                          }}
                        >
                          <b>
                            ✔{" "}
                            {presente?.dependencia ||
                              "Sin dependencia"}
                          </b>

                          <span>
                            {formatearFechaPresente(
                              presente?.fecha
                            )}{" "}
                            {formatearHoraPresente(
                              presente?.hora
                            )}
                          </span>

                          {presente?.usuario && (
                            <small>
                              {presente.usuario}
                            </small>
                          )}

                          <small>
                            📍 {getNombreSede(presente?.sedeID)}
                          </small>
                        </div>
                      )
                    )}
                  </div>
                ) : (
                  <div style={styles.ausentePsicoMobile}>
                    Sin presentes
                  </div>
                )}
              </div>

              {p.instancias?.map((inst) => (
                <div key={inst.id} style={{ marginTop: 8 }}>
                  <b>{inst.nombre}</b>

                  <div style={styles.itemsContainer}>
                    {inst.items?.map((item, i) => (
                      <span
                        key={item.id}
                        onClick={() => handleClickItem(p, inst, item)}
                        style={{
                          ...styles.itemChipMobile,
                          cursor: puedeAccionarItem(item)
                            ? "pointer"
                            : "not-allowed",
                          opacity: puedeAccionarItem(item) ? 1 : 0.6,
                          background: getColor(item),
                        }}
                        title={item.descripcion || item.nombre || ""}
                      >
                        {item.descripcion || item.nombre || `Item ${i + 1}`}{" "}
                        {getIcon(item)}
                      </span>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>
      )}

      {filteredData.length === 0 && <p>No hay inscriptos</p>}

      {modalOpen && itemSeleccionado && (
        <div style={styles.modalFondo}>
          <div style={styles.modalContenido}>
            <button
              onClick={() => {
                setModalOpen(false);
                setItemSeleccionado(null);
                setTipoModal(null);
                fetchData();
              }}
              style={styles.btnCerrar}
            >
              ❌
            </button>

            {tipoModal === "examen" && (
              <ModuloPiscologiaIngreso
                datos={itemSeleccionado}
                etapa={etapa}
                refres={fetchData}
              />
            )}

            {tipoModal === "archivo" && (
              <UploadArchivosItem
                datos={itemSeleccionado}
                etapa={etapa}
                refres={fetchData}
              />
            )}

            {tipoModal === "video" && (
  <EvaluarVideoEntrevista
    dni={itemSeleccionado.persona.dni}
    procesoId={itemSeleccionado.item.proceso_id || etapa.proceso_id}
    itemId={itemSeleccionado.item.id}
    estadoInicial={itemSeleccionado.item.estado || "cargado"}
    notaInicial={itemSeleccionado.item.resultado || ""}
    observacionesIniciales={itemSeleccionado.item.observaciones || ""}
    onGuardado={() => {
      setModalOpen(false);
      setItemSeleccionado(null);
      setTipoModal(null);
      fetchData();
    }}
  />
)}
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  resumenPresentesGeneral: {
    marginTop: 8,
    display: "flex",
    flexDirection: "column",
    gap: 4,
    fontSize: 13,
    color: "#166534",
  },

  asistenciaPorFechaContainer: {
    marginTop: 14,
    padding: 12,
    border: "1px solid #bbf7d0",
    borderRadius: 10,
    background: "#f0fdf4",
  },

  asistenciaPorFechaHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    flexWrap: "wrap",
    marginBottom: 10,
  },

  asistenciaAyuda: {
    marginTop: 3,
    fontSize: 12,
    color: "#475569",
  },

  asistenciaFechaManual: {
    display: "flex",
    alignItems: "center",
    gap: 7,
  },

  inputFechaAsistencia: {
    padding: "7px 9px",
    borderRadius: 7,
    border: "1px solid #86efac",
    background: "#fff",
  },

  btnLimpiarAsistencia: {
    padding: "7px 9px",
    borderRadius: 7,
    border: "1px solid #cbd5e1",
    background: "#fff",
    cursor: "pointer",
  },

  fechasAsistenciaGrid: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },

  cardAsistenciaFecha: {
    minWidth: 205,
    padding: 10,
    border: "2px solid #bbf7d0",
    borderRadius: 9,
    background: "#ffffff",
  },

  fechaAsistenciaTitulo: {
    fontWeight: "bold",
    marginBottom: 8,
    color: "#0f172a",
  },

  btnFechaPresentes: {
    width: "100%",
    marginBottom: 6,
    padding: "7px 9px",
    borderRadius: 7,
    border: "1px solid #86efac",
    background: "#dcfce7",
    color: "#166534",
    cursor: "pointer",
    textAlign: "left",
  },

  btnFechaPresentesActivo: {
    background: "#16a34a",
    color: "#ffffff",
    border: "1px solid #15803d",
    outline: "2px solid #15803d",
  },

  btnFechaAusentes: {
    width: "100%",
    marginBottom: 6,
    padding: "7px 9px",
    borderRadius: 7,
    border: "1px solid #fcd34d",
    background: "#fef3c7",
    color: "#92400e",
    cursor: "pointer",
    textAlign: "left",
  },

  btnFechaAusentesActivo: {
    background: "#f59e0b",
    color: "#ffffff",
    border: "1px solid #d97706",
    outline: "2px solid #d97706",
  },

  totalFechaAsistencia: {
    fontSize: 12,
    color: "#475569",
    marginTop: 3,
  },

  filtroFechaActivo: {
    marginTop: 10,
    padding: "8px 10px",
    borderRadius: 7,
    background: "#dbeafe",
    border: "1px solid #93c5fd",
    color: "#1e3a8a",
    fontSize: 13,
  },

  sinFechasAsistencia: {
    padding: 10,
    color: "#64748b",
    fontSize: 13,
  },

  presentesContainer: {
    display: "flex",
    gap: 5,
    flexWrap: "wrap",
    minWidth: 220,
    maxWidth: 420,
  },

  presenteDependenciaChip: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    gap: 2,
    border: "none",
    borderRadius: 7,
    padding: "6px 9px",
    cursor: "pointer",
    fontSize: 10,
    minWidth: 105,
    boxShadow: "0 1px 3px rgba(0,0,0,0.18)",
  },

  usuarioPresente: {
    fontSize: 9,
    opacity: 0.9,
    maxWidth: 140,
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  sedePresente: {
    fontSize: 9,
    fontWeight: "bold",
    opacity: 0.95,
  },

  sedesContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 4,
  },

  sedeChip: {
    display: "inline-block",
    padding: "5px 8px",
    borderRadius: 7,
    background: "#e0f2fe",
    border: "1px solid #7dd3fc",
    color: "#075985",
    fontWeight: "bold",
    fontSize: 11,
    width: "fit-content",
  },

  sinSedeChip: {
    color: "#94a3b8",
    fontSize: 14,
  },

  presentesMobileContainer: {
    display: "flex",
    flexDirection: "column",
    gap: 5,
  },

  presenteDependenciaMobile: {
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: "7px 9px",
    borderRadius: 7,
    cursor: "pointer",
    fontSize: 12,
  },

  resumenContainer: {
    display: "flex",
    gap: 15,
    flexWrap: "wrap",
    marginTop: 10,
  },
  cardMatriculados: {
    border: "1px solid #ddd",
    borderRadius: 8,
    padding: 10,
    minWidth: 180,
    background: "#eff6ff",
  },
  numeroMatriculados: {
    fontSize: 22,
    marginTop: 5,
    fontWeight: "bold",
  },
  cardResumen: {
    border: "1px solid #ddd",
    borderRadius: 8,
    padding: 10,
    minWidth: 180,
    background: "#fafafa",
  },
  resumenTexto: {
    fontSize: 13,
    marginTop: 5,
  },
  filtroSedeActivo: {
    marginTop: 10,
    padding: "8px 10px",
    borderRadius: 8,
    background: "#e0f2fe",
    border: "1px solid #7dd3fc",
    color: "#075985",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    gap: 8,
    flexWrap: "wrap",
  },

  btnLimpiarSede: {
    padding: "4px 8px",
    borderRadius: 6,
    border: "1px solid #0284c7",
    background: "#ffffff",
    color: "#075985",
    fontWeight: "bold",
    cursor: "pointer",
  },

  paginador: {
    marginTop: 15,
    display: "flex",
    gap: 10,
    alignItems: "center",
  },
  buscadorContainer: {
    display: "flex",
    gap: 10,
    marginTop: 10,
  },
  inputBuscar: {
    flex: 1,
    padding: 8,
    borderRadius: 8,
    border: "1px solid #ccc",
  },
  selectOrdenAlfabetico: {
    padding: "8px 10px",
    borderRadius: 8,
    border: "1px solid #94a3b8",
    background: "#fff",
    minWidth: 170,
    cursor: "pointer",
  },
  presentePsicoChip: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 2,
    border: "none",
    borderRadius: 7,
    background: "#22c55e",
    color: "#fff",
    padding: "6px 9px",
    cursor: "pointer",
    fontSize: 11,
    minWidth: 150,
  },

  ausentePsicoChip: {
    color: "#94a3b8",
    fontSize: 16,
  },

  presentePsicoMobile: {
    display: "flex",
    justifyContent:
      "space-between",
    alignItems: "center",
    gap: 8,
    padding: "7px 9px",
    borderRadius: 7,
    background: "#dcfce7",
    border:
      "1px solid #86efac",
    color: "#166534",
    cursor: "pointer",
    fontSize: 12,
  },

  ausentePsicoMobile: {
    padding: "6px 8px",
    borderRadius: 7,
    background: "#f8fafc",
    border:
      "1px solid #e2e8f0",
    color: "#94a3b8",
    fontSize: 12,
  },

  tabla: {
    width: "100%",
    minWidth: 1300,
    marginTop: 10,
    borderCollapse: "collapse",
    fontSize: 13,
  },
  th: {
    border: "1px solid #ddd",
    padding: "8px 6px",
    background: "#e5e7eb",
    position: "sticky",
    top: 0,
    zIndex: 2,
    whiteSpace: "nowrap",
  },
  td: {
    border: "1px solid #e5e7eb",
    padding: "7px 6px",
    verticalAlign: "top",
    whiteSpace: "nowrap",
  },
  itemsContainer: {
    display: "flex",
    gap: 4,
    flexWrap: "wrap",
  },
  itemChip: {
    padding: "2px 6px",
    borderRadius: 4,
    display: "inline-block",
    fontSize: 12,
  },
  itemChipMobile: {
    padding: "4px 6px",
    borderRadius: 6,
    display: "inline-block",
    fontSize: 12,
  },
  cardMobile: {
    border: "1px solid #ddd",
    borderRadius: 8,
    marginBottom: 10,
    padding: 10,
  },
  modalFondo: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    background: "rgba(0,0,0,0.5)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 9999,
  },
  modalContenido: {
    background: "#fff",
    padding: 20,
    borderRadius: 10,
    minWidth: 300,
    maxHeight: "90%",
    overflow: "auto",
  },
  btnCerrar: {
    float: "right",
  },
};

export default ListadoInscriptoPsico;